var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6064_1989",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6064_1989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.24982 15C8.03732 15 7.85919 14.9281 7.71544 14.7844C7.57169 14.6406 7.49982 14.4625 7.49982 14.25V9.75L3.14982 4.2C2.96232 3.95 2.93419 3.6875 3.06544 3.4125C3.19669 3.1375 3.42482 3 3.74982 3H14.2498C14.5748 3 14.8029 3.1375 14.9342 3.4125C15.0654 3.6875 15.0373 3.95 14.8498 4.2L10.4998 9.75V14.25C10.4998 14.4625 10.4279 14.6406 10.2842 14.7844C10.1404 14.9281 9.96232 15 9.74982 15H8.24982ZM8.99982 9.225L12.7123 4.5H5.28732L8.99982 9.225Z",
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterAlt);
export default __webpack_public_path__ + "static/media/FilterAlt.7736b862050dc80e957c50900a037958.svg";
export { ForwardRef as ReactComponent };